export const brandColors = {
  brandOne: '#341F73',
  brandTwo: '#228300',
} as const;
